module.exports = __webpack_public_path__ + "d393ec87256122a227d65796ea5cbd6d.mp4";